<template>
  <div class="q-attr-picker mb-3">
    <span class="q-form-label">{{ group.name }}</span>

    <!-- Color swatches -->
    <div v-if="group.class === 'color'" class="q-attr-colors">
      <a
        v-for="att in group.attributes" :key="att.id"
        class="q-color-swatch"
        :class="{ 'q-color-swatch--active': isSelected(att.id) }"
        :style="getStyle(att.data)"
        :title="att.name"
        @click="toggle(att.id)"
      ></a>
    </div>

    <!-- Tag pills -->
    <div v-if="group.class === 'tag'" class="q-attr-tags">
      <a
        v-for="att in group.attributes" :key="att.id"
        class="q-attr-tag"
        :class="{ 'q-attr-tag--active': isSelected(att.id) }"
        @click="toggle(att.id)"
      >{{ att.name }}</a>
    </div>

    <!-- Select -->
    <div v-if="group.class === 'list'">
      <select class="form-select form-select-sm q-attr-select" v-model="selected">
        <option :value="0">Ninguna</option>
        <option v-for="opt in group.attributes" :key="opt.id" :value="opt.id">{{ opt.name }}</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  props: ["group"],
  data() { return { selected: 0, preval: 0 }; },
  methods: {
    toggle(id) { this.selected = this.selected === id ? 0 : id; },
    isSelected(id) { return this.selected === id; },
    getStyle(field) {
      const data = JSON.parse(field);
      return `background-color: ${data.code};`;
    },
  },
  watch: {
    selected() {
      if (this.preval !== 0) this.$emit("update", this.preval);
      this.preval = this.selected;
      this.$emit("update", this.selected);
    },
  },
};
</script>

<style scoped>
.q-form-label {
  font-family: var(--q-font-display);
  font-size: 10px; font-weight: 600;
  letter-spacing: 0.1em; text-transform: uppercase;
  color: var(--q-text-muted); display: block; margin-bottom: 8px;
}

.q-attr-colors { display: flex; flex-wrap: wrap; gap: 6px; }
.q-color-swatch {
  width: 26px; height: 26px;
  border-radius: 4px;
  cursor: pointer;
  border: 2px solid transparent;
  transition: border-color var(--q-transition), transform var(--q-transition);
}
.q-color-swatch:hover { transform: scale(1.1); }
.q-color-swatch--active { border-color: var(--primary-color); box-shadow: 0 0 0 1px var(--primary-color); }

.q-attr-tags { display: flex; flex-wrap: wrap; gap: 6px; }
.q-attr-tag {
  padding: 4px 12px;
  border: 1px solid var(--q-border);
  border-radius: var(--q-radius-sm);
  font-size: 12px;
  color: var(--q-text-muted);
  cursor: pointer;
  font-family: var(--q-font-mono);
  transition: all var(--q-transition);
}
.q-attr-tag:hover { border-color: var(--primary-color); color: var(--primary-color); }
.q-attr-tag--active {
  border-color: var(--primary-color);
  background: rgba(0, 112, 243, 0.12);
  color: var(--primary-color);
}

.q-attr-select { max-width: 240px; }
</style>
